import { atom } from "recoil";

export const achievementCategoryAddModalStore = atom({
	key: "achievementCategoryAddModalStore",
	default: {
		show: false,
		loaded: true,
		name: "",
		type: "",
		active: false,
		currentOptions: {
			type: [
				{ value: "daily", label: "Daily" },
				{ value: "unique", label: "Unique" },
				{ value: "progressive", label: "Progressive" },
			]
		}
	},
});
